import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

const SireComment = ({ sireComment, isWeatherbysMobile }) => {
    if (isWeatherbysMobile) {
        return (
            !!sireComment && (
                <Definition
                    isTermLabel={false}
                    forceShow
                    term={sireComment}
                    description=""
                />
            )
        );
    }

    return (
        !!sireComment && (
            <Definition
                term="Sire comment"
                description={sireComment}
            />
        )
    );
};

SireComment.propTypes = {
    sireComment: PropTypes.string,
    isWeatherbysMobile: PropTypes.bool,
};

export default SireComment;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/SireComment.jsx